import React from 'react'
import './coupon-list.less'
import { connect } from 'react-redux'
import Checkbox from '@/components/checkbox/checkbox'
import { SET_COUPON_NO } from '@/action-types/shopping-car'
import { setHeader } from '@/util/set-header'
const mapStateToProps = (state: any) => {
  return {
    coupon_list: state.shoppingCar.coupon_list,
    coupon_no: state.shoppingCar.coupon_no,
  }
}
const mapDispatchToProps = (dispatch: any) => ({
  setCouponNoAction: (coupon_no: any) =>
    dispatch({ type: SET_COUPON_NO, coupon_no }),
})
@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
class GoodsList extends React.Component<any, any> {
  private depot_id: string
  private type: string
  constructor(props: any) {
    super(props)
    const { match } = this.props
    this.depot_id = match.params.depot_id
    this.type = match.params.type
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '选择优惠券' })
    this.setCoupnNo = this.setCoupnNo.bind(this)
  }

  async setCoupnNo(item: any) {
    if (!item.is_enable) {
      return
    }
    const { setCouponNoAction, history } = this.props
    await setCouponNoAction(item.trade_no)
    history.push(`/fillorder/prepare/${this.type}/${this.depot_id}`)
  }
  render() {
    const { coupon_list, coupon_no } = this.props

    const listItems = coupon_list.map((item: any) => (
      <div
        key={item.id}
        className="coupon"
        onClick={() => this.setCoupnNo(item)}
      >
        <i className="iconfont">&#xe66b;</i>
        <span className="font-7 character-new">新</span>
        {//半透明
        !item.is_enable && <div className="translucent" />}
        <div className="co-item">
          <div>
            <p className={item.is_enable ? 'font-4 notice-color' : 'font-4'}>
              ￥{item.price}
            </p>
            <p className="font-8 font_gray">{item.type}</p>
          </div>
          <div className="co-date">
            <p className="font-5">{item.title}</p>
            <p className="font-8">{`${item.start_time}-${item.end_time}`}</p>
          </div>
          <Checkbox checked={coupon_no === item.trade_no} />
        </div>
        {item.text && <p className="co-text notice-color">{item.text}</p>}

        <div className="co-notice">{item.brief}</div>
      </div>
    ))
    return (
      <div>
        <div className="coupon-list">
          <div
            className="no-coupon"
            onClick={() => this.setCoupnNo({ is_enable: true, trade_no: '' })}
          >
            <span>不使用优惠券</span>
            <Checkbox checked={!coupon_no} />
          </div>
          <div className="header-coupon">
            有
            <span className="notice-color">
              &nbsp;{coupon_list.length}&nbsp;
            </span>
            张优惠券
          </div>

          {listItems}
        </div>
      </div>
    )
  }
}

export default GoodsList
